import { Grid, Heading, Paragraph, styled } from "@health-zelas/delta"

export const Preferences = styled('div', {
  margin: '0 auto',
  padding: '0 $xxs $lg'
})

export const FullWidthGrid = styled(Grid, {
  width: '100%',
  maxWidth: '1140px',
  margin: '0 auto'
})

export const LeftSide = styled('div', {
  '@md': {
    maxWidth: '460px',
    paddingRight: '60px'
  },
  maxWidth: '558px',
  margin: '0 auto $md'
})
export const RightSide = styled('div', {
  '@md': {
    paddingLeft: '60px'
  },
  maxWidth: '558px',
  margin: '0 auto'
})

export const StepTitle = styled(Heading, {
  color: '$neutralDarkest',
  fontWeight: '$bold',
  marginBottom: '$xxs',
  fontFamily: '$primary',
  '@md': {
    marginBottom: '$xs',
  }
})

export const Presentation = styled(Paragraph, {
  color: '$neutralDark',
  marginBottom: '$sm',
  '@md': {
    marginBottom: '$md',
  }
})

export const ButtonGroup = styled('div', {
  display: 'flex',
  flexDirection: 'column-reverse',
  gap: '$xxxs',
  marginTop: '$md',

  '@sm': {
    marginTop: '$lg',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  }
})
